import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import DateTime from 'react-datetime';
import {ControlLabel, FormGroup} from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';

class DatePicker extends Component {
  state = {
    value: ''
  };
  handleChange = (value) => {
    const {model, dispatch} = this.props;

    if (typeof value === 'object') {
      this.setState({
        value,
      });

      dispatch(actions.change(model, value.format()));
    } else {
      this.setState({
        value: '',
      });
      dispatch(actions.change(model, ''));
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      const value = nextProps.value ? moment(nextProps.value) : '';
      this.setState({
        value
      });

      if (value) {
        this.props.dispatch(actions.change(this.props.model, value.format()));
      }
    }
  }

  componentDidMount() {
    const {value} = this.props;
    if (this.state.value === '') {
      this.componentWillReceiveProps({value});
    }
    // dispatch(actions.change(model, this.state.value));
  }

  render() {
    return (
      <FormGroup
        className="ignite-datepicker"
        controlId={this.props.controlId}
      >
        {this.props.label && (
          <ControlLabel>
            {this.props.label}
          </ControlLabel>
        )}
        <DateTime
          className={this.props.classNames}
          closeOnSelect={!this.props.timeFormat}
          dateFormat={this.props.dateFormat}
          inputProps={{
            disabled: this.props.disabled,
            placeholder: this.props.placeholder,
            // Thanks to Chrome: https://bugs.chromium.org/p/chromium/issues/detail?id=587466
            autoComplete: `${+new Date()}-${Math.random()}`,
          }}
          onChange={this.handleChange}
          timeFormat={this.props.timeFormat}
          value={this.state.value}
        />
      </FormGroup>
    );
  }
}

DatePicker.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  dateFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  timeFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disabled: PropTypes.any
};

DatePicker.defaultProps = {
  dateFormat: 'DD/MM/YYYY',
  timeFormat: false
};

export default connect()(DatePicker);



// WEBPACK FOOTER //
// ./src/components/common/form/datepicker.jsx